import { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { IAppState } from 'config/redux/reducers';
import { EScreens } from 'pages/Checkout/types/screen.types';

import {
  setScreenToAddressList,
  setScreenToAddressForm,
  setScreen,
} from 'pages/Checkout/redux/actions/screen.actions';

const useScreen = (): [
  {
    isAddressList: boolean;
    isCartList: boolean;
    isNewAddress: boolean;
    isCNCPickStores: boolean;
    isCNCPickStoresChange: boolean;
    isCNCValidateCart: boolean;
    isHide: boolean;
  },
  {
    onShowAddressListHandler: () => any;
    onShowAddressFormHandler: () => any;
    onHideScreenHandler: () => any;
    onShowCNCPickupStoresHandler: () => any;
    onShowCNCPickupStoresChangeHandler: () => any;
    onShowCNCValidateCartHandler: () => any;
  }
] => {
  const dispatch = useDispatch();

  const screen = useSelector(({ checkout: { delivery } }: IAppState) => delivery.screen);

  const onShowAddressListHandler = useCallback(() => dispatch(setScreenToAddressList()), [
    dispatch,
  ]);
  const onShowAddressFormHandler = useCallback(() => dispatch(setScreenToAddressForm()), [
    dispatch,
  ]);
  const onHideScreenHandler = useCallback(() => dispatch(setScreen()), [dispatch]);
  const onShowCNCPickupStoresHandler = useCallback(
    () => dispatch(setScreen(EScreens.CNC_PICKUP_STORES)),
    [dispatch]
  );
  const onShowCNCPickupStoresChangeHandler = useCallback(
    () => dispatch(setScreen(EScreens.CNC_PICKUP_STORES_CHANGE)),
    [dispatch]
  );
  const onShowCNCValidateCartHandler = useCallback(
    () => dispatch(setScreen(EScreens.CNC_VALIDATE_CART)),
    [dispatch]
  );

  return [
    {
      isAddressList: screen === EScreens.ADDRESS_LIST,
      isCartList: screen === EScreens.CART_LIST,
      isNewAddress: screen === EScreens.ADDRESS_FORM,
      isCNCPickStores: screen === EScreens.CNC_PICKUP_STORES,
      isCNCPickStoresChange: screen === EScreens.CNC_PICKUP_STORES_CHANGE,
      isCNCValidateCart: screen === EScreens.CNC_VALIDATE_CART,
      isHide: screen === '',
    },
    {
      onShowAddressListHandler,
      onShowAddressFormHandler,
      onHideScreenHandler,
      onShowCNCPickupStoresHandler,
      onShowCNCPickupStoresChangeHandler,
      onShowCNCValidateCartHandler,
    },
  ];
};

export default useScreen;
